import { useState } from 'react'

export const useAttachmentNotes = () => {
  const [currentNoteField, setCurrentNoteField] = useState('')
  const getCurrentNoteField = (field) => setCurrentNoteField(field)

  return [getCurrentNoteField, currentNoteField]
}

export default useAttachmentNotes
